import {
	PostRequestUploadFileParams,
	PostRequestUploadFileResponse,
} from 'domain/usecases/others/facial-biometric';
import {makePostRequestFacialBiometricUploadFile} from 'main/factories/usecases/others/facial-biometric/request/post-upload-file';

export const postUploadFile = async (
	params: PostRequestUploadFileParams,
): Promise<PostRequestUploadFileResponse> => {
	const response = await makePostRequestFacialBiometricUploadFile().post(params);
	return response;
};
